import { useDispatch, useSelector } from "react-redux";
import React, { useEffect, useState } from "react";
import { isEmpty } from "lodash";
import { toast } from "react-toastify";
import DeleteModal from "../../../../Components/Common/DeleteModal";
import StatusViewEditComponent from "../../company/components/statusViewEditComponent";
import SettingsPanel from "../../components/SettingsPanel";
import {
  createMasterPaymentProvider,
  createMasterPaymentProviderSuccess,
  deleteMasterPaymentProvider,
  deleteMasterPaymentProviderSuccess,
  getMasterPaymentProviderList,
  updateMasterPaymentProvider,
  updateMasterPaymentProviderSuccess,
} from "../../../../store/masterPaymentProvider/action";

const MasterPaymentProvider = () => {
  {
    const dispatch = useDispatch();

    const [statusList, setStatusList] = useState([]);
    const [activeTab] = useState("1");
    const [deleteStatus, setDeleteStatus] = useState("");
    const [config, setConfig] = useState(null);
    const [createStatus, setCreateStatus] = useState({
      Name: "New Status",
      CssColourText: "#000000",
      CssColourBackground: "#F4F0F0",
      IntervalValueMathSign: "+",
      IntervalValue: 7,
      MasterTimeFrameInterval_Id: "1",
    });

    const { masterPaymentProvidersListAPI } = useSelector((state) => ({
      masterPaymentProvidersListAPI:
        state.MasterPaymentProvider.masterPaymentProvidersList
          ?.masterpaymentprovider_list,
    }));

    const handleCreateNewStatus = () => {
      if (activeTab === "1") {
        dispatch(createMasterPaymentProvider([createStatus]));
      }
    };

    useEffect(() => {
      let data = [];

      if (activeTab === "1") {
        data = masterPaymentProvidersListAPI?.sort((a, b) => b.Id - a.Id);
        // setConfig({
        //   name: "generalSettingsMasterFrequency",
        // });
      }
      setStatusList(data);
    }, [activeTab, masterPaymentProvidersListAPI]);

    useEffect(() => {
      dispatch(getMasterPaymentProviderList());
    }, []);

    const [deleteModal, setDeleteModal] = useState(false);
    const handleDeleteStatus = () => {
      if (activeTab === "1") {
        dispatch(deleteMasterPaymentProvider([deleteStatus]));
      }
    };
    const [updateItemStatus, setUpdateItemStatus] = useState({});

    // Update Module
    useEffect(() => {
      if (isEmpty(updateItemStatus)) return;
      let updateNewStatus = {
        Id: updateItemStatus?.Id,
        Name: updateItemStatus?.Name,
        CssColourBackground: updateItemStatus?.CssColourBackground,
        CssColourText: updateItemStatus?.CssColourText,
        IntervalValue: updateItemStatus?.IntervalValue,
        IntervalValueMathSign: updateItemStatus?.IntervalValueMathSign,
        MasterTimeFrameInterval_Id:
          updateItemStatus?.MasterTimeFrameInterval_Id,
      };
      const delayUpdate = setTimeout(() => {
        if (activeTab === "1") {
          dispatch(updateMasterPaymentProvider([updateNewStatus]));
        }
      }, 500);
      return () => clearTimeout(delayUpdate);
    }, [updateItemStatus]);

    //Effects
    const {
      createMasterPaymentProviderSuccessAPI,
      updateMasterPaymentProviderSuccess,
      deleteMasterPaymentProviderSuccess,
    } = useSelector((state) => ({
      createMasterPaymentProviderSuccessAPI:
        state.MasterPaymentProvider.createMasterPaymentProviderSuccess,
      updateMasterPaymentProviderSuccess:
        state.MasterPaymentProvider.updateMasterPaymentProviderSuccess,
      deleteMasterPaymentProviderSuccess:
        state.MasterPaymentProvider.deleteMasterPaymentProviderSuccess,
    }));
    // Effect create master time frame success
    useEffect(() => {
      if (isEmpty(createMasterPaymentProviderSuccessAPI)) return;
      if (createMasterPaymentProviderSuccessAPI?.status === 200) {
        toast.success(createMasterPaymentProviderSuccessAPI?.message);
        dispatch(getMasterPaymentProviderList());
      } else {
        toast.error(createMasterPaymentProviderSuccessAPI?.message);
      }
      dispatch(createMasterPaymentProviderSuccess([]));
    }, [createMasterPaymentProviderSuccessAPI]);

    // Effect update master time frame success
    useEffect(() => {
      if (isEmpty(updateMasterPaymentProviderSuccess)) return;
      if (updateMasterPaymentProviderSuccess?.status === 200) {
        toast.success(updateMasterPaymentProviderSuccess?.message);
        dispatch(getMasterPaymentProviderList());
      } else {
        toast.error(updateMasterPaymentProviderSuccess?.message);
      }
      dispatch(updateMasterPaymentProviderSuccess([]));
    }, [updateMasterPaymentProviderSuccess]);

    // Effect delete master time frame success
    useEffect(() => {
      if (isEmpty(deleteMasterPaymentProviderSuccess)) return;
      if (deleteMasterPaymentProviderSuccess?.status === 200) {
        toast.success(deleteMasterPaymentProviderSuccess?.message);
        dispatch(getMasterPaymentProviderList());
        setDeleteModal(false);
      } else {
        toast.error(deleteMasterPaymentProviderSuccess?.message);
      }
      dispatch(deleteMasterPaymentProviderSuccess([]));
    }, [deleteMasterPaymentProviderSuccess]);

    return (
      <>
        {deleteModal && (
          <DeleteModal
            show={deleteModal}
            onDeleteClick={handleDeleteStatus}
            onCloseClick={() => {
              setDeleteModal(false);
            }}
          />
        )}

        <SettingsPanel
          title="Master Payment Provider"
          description="Payment providers available to every company."
        >
          <StatusViewEditComponent
            statusList={statusList}
            setStatusList={setStatusList}
            createStatus={createStatus}
            setCreateStatus={setCreateStatus}
            handleCreateNewStatus={handleCreateNewStatus}
            setDeleteStatus={setDeleteStatus}
            setDeleteModal={setDeleteModal}
            setUpdateItemStatus={setUpdateItemStatus}
            // config={config}
          />
        </SettingsPanel>
      </>
    );
  }
};

export default MasterPaymentProvider;
